var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { isErr } from "healthex-common/result";
import { t } from "i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
export class ExpiredPasswordViewModel {
    constructor(container) {
        this.input = { currentPassword: "", newPassword: "", reEnteredNewPassword: "" };
        this.newPasswordSaved = false;
        this.error = null;
        this.expiredPasswordUIManager = container.expiredPasswordUIManager;
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.passwordValidator = container.passwordValidator;
    }
    get organization() {
        return this.expiredPasswordUIManager.organization;
    }
    get organizationPasswordConfiguration() {
        var _a;
        if (this.organization === NOT_LOADED)
            return null;
        return (_a = this.organization) === null || _a === void 0 ? void 0 : _a.passwordConfiguration;
    }
    get userEmail() {
        return this.expiredPasswordUIManager.userEmailAddress;
    }
    updateInput(update) {
        this.error = null;
        this.input = { ...this.input, ...update };
    }
    async updatePassword() {
        const validationResult = this.passwordValidator.validate(this.input.newPassword, this.input.reEnteredNewPassword, this.input.currentPassword, null, null, this.organizationPasswordConfiguration);
        if (isErr(validationResult)) {
            this.error = this.getValidationErrorMessage(validationResult.error);
        }
        if (this.userEmail) {
            const result = await this.authManager.changePassword({
                email: this.userEmail,
                password: this.input.newPassword,
                currentPassword: this.input.currentPassword,
                reEnteredNewPassword: this.input.reEnteredNewPassword,
            });
            if (isErr(result)) {
                switch (result.error) {
                    case "INCORRECT_CREDENTIALS":
                        this.error = t("Incorrect current password! Please try again.");
                        break;
                    case "ACCOUNT_LOCKED":
                        this.error = t("Your account is temporarily locked to prevent unauthorized use. You can either reset your password or try again later. If you still have trouble, contact your administrator.");
                        break;
                    case "OLD_PASSWORD_REUSED":
                        this.error = this.getValidationErrorMessage("OLD_PASSWORD_REUSED");
                        break;
                    default:
                        this.error = t("An unexpected error occurred");
                }
                return;
            }
            this.newPasswordSaved = true;
        }
    }
    async navigateToLoginPage() {
        this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_ORG_USER);
    }
    getValidationErrorMessage(validationError) {
        switch (validationError) {
            case "OLD_PASSWORD_REUSED":
                return t("Old password cannot be reused. Please use a new password");
            case "PASSWORD_MISMATCH":
                return t("Passwords don't match! Please try again.");
            case "PASSWORD_CRITERIA_MISMATCH":
                return t("Password doesn't meet the requirements! Please try again.");
            case "SSO_ENABLED":
                return t("Password cannot be changed when SSO is enabled.");
            default:
                return t("An unexpected error occurred");
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ExpiredPasswordViewModel.prototype, "input", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ExpiredPasswordViewModel.prototype, "newPasswordSaved", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ExpiredPasswordViewModel.prototype, "error", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ExpiredPasswordViewModel.prototype, "organization", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ExpiredPasswordViewModel.prototype, "organizationPasswordConfiguration", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ExpiredPasswordViewModel.prototype, "userEmail", null);
